<template>
  <div class="checkbox-group">
    <div class="checkbox-group__label">
      <strong>{{ label }}</strong>
    </div>
    <v-checkbox
      dark
      dense
      ripple
      v-for="checkbox of checkboxes"
      :ref="checkbox.name"
      :key="checkbox.name"
      v-model="checkboxesValues[checkbox.name]"
      :label="checkbox.label"
      color="#fff"
      :off-icon="icons.blankCheckbox"
      :on-icon="icons.markedCheckbox"
      @change="onChange"
    ></v-checkbox>
  </div>
</template>

<script>
  import { mdiCheckboxBlankOutline, mdiCheckboxMarkedOutline } from '@mdi/js'

  export default {
    name: 'CheckboxesGroup',

    props: {
      label: {
        required: true,
        type: String,
      },

      name: {
        required: true,
        type: String,
      },

      checkboxes: {
        required: true,
        type: Array,
      },
    },

    data() {
      return {
        checkboxesValues: {},
        checkboxesValuesAllTrue: {},
        icons: {
          blankCheckbox: mdiCheckboxBlankOutline,
          markedCheckbox: mdiCheckboxMarkedOutline,
        },
      }
    },

    methods: {
      onChange() {
        const filterIsUsed = Object.keys(this.checkboxesValues).some((key) => {
          const checkbox = this.checkboxesValues[key]

          return !!checkbox
        })

        const eventPayload = filterIsUsed
          ? {
            name: this.name,
            values: this.checkboxesValues,
          }
          : {
            name: this.name,
            values: this.checkboxesValuesAllTrue,
          }

        this.$emit('change', eventPayload)
      },
    },

    mounted() {
      this.checkboxes.forEach((checkbox) => {
        this.checkboxesValues[checkbox.name] = false
        this.checkboxesValuesAllTrue[checkbox.name] = true
      })

      this.onChange()
    },
  }
</script>

<style lang="sass" scoped>
  .checkbox-group__label
    margin-bottom: 20px

  .v-input--dense
    margin-top: 0

  .checkbox-group ::v-deep .theme--dark.v-label
    color: #fff !important
</style>
